import { defineStore } from 'pinia'

import type { KidStore } from '@stores/kid/interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useKidStore = defineStore('kid', {
  state: (): KidStore => ({
    activeKidId: null,
    _hydrated: false,
    activeKidDisciplines: [],
  }),
  actions,
  getters,
})
